import {routes, request} from "./"

export function loadAllUsers (commit) {
    return request(commit, routes.users.loadAll)
}

export function loadUsersPage (commit, data) {
    return request(commit, routes.users.loadPage, data)
}

export function searchUsers (commit, data) {
    return request(commit, routes.users.loadSearch, data, 'post')
}

export function createUser (commit, data) {
    return request(commit, routes.users.create, data, 'post')
}

export function updateUser (commit, data) {
    return request(commit, routes.users.update, data, 'post')
}

export function deleteUser (commit, data) {
    return request(commit, routes.users.delete, data, 'post')
}

export function loadUser (commit, data) {
    return request(commit, routes.users.load, data, 'post')
}

export function setPrimaryRecipient(commit, data) {
    return request(commit, routes.users.setPrimaryRecipient, data, 'post')
}

export function createUserRecipient (commit, data) {
    return request(commit, routes.users.createRecipient, data, 'post')
}

export function updateUserRecipient (commit, data) {
    return request(commit, routes.users.updateRecipient, data, 'post')
}

export function deleteUserRecipient (commit, data) {
    return request(commit, routes.users.deleteRecipient, data, 'post')
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/users.js
// module id = 612
// module chunks = 0